<template>
  <ion-modal
    :is-open="isOpen"
    :backdrop-dismiss="!force"
    class="version-outdated-modal"
    @didDismiss="onBackdropDismiss"
  >
    <div class="version-outdated-modal__wrap">
      <div class="version-outdated-modal__spacer" aria-hidden="true"></div>
      <div class="version-outdated-modal__card">
        <h2 class="version-outdated-modal__title">Actualiza la aplicación</h2>
        <p class="version-outdated-modal__text">{{ mensaje }}</p>
        <p class="version-outdated-modal__meta">
          Tu versión: <strong>{{ localVersion }}</strong>
          <template v-if="info?.version_latest">
            · Disponible: <strong>{{ info.version_latest }}</strong>
          </template>
        </p>

        <div class="version-outdated-modal__buttons">
          <ion-button expand="block" color="primary" @click="onActualizar">
            Actualizar ahora
          </ion-button>
          <ion-button expand="block" color="success" @click="onWhatsapp">
            <ion-icon slot="start" :icon="logoWhatsapp"></ion-icon>
            Pedir asistencia por WhatsApp
          </ion-button>
          <ion-button
            v-if="!force"
            expand="block"
            fill="clear"
            class="version-outdated-modal__later"
            @click="onMasTarde"
          >
            Más tarde
          </ion-button>
        </div>
      </div>
      <div class="version-outdated-modal__spacer" aria-hidden="true"></div>
    </div>
  </ion-modal>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { IonButton, IonIcon, IonModal } from '@ionic/vue'
import { logoWhatsapp } from 'ionicons/icons'
import { useAppVersionCheck } from '@/composables/useAppVersionCheck'

const {
  isOpen,
  info,
  force,
  mensaje,
  localVersion,
  start,
  onActualizar,
  onWhatsapp,
  onMasTarde,
} = useAppVersionCheck()

onMounted(() => {
  start()
})

function onBackdropDismiss(): void {
  if (!force.value && isOpen.value) {
    onMasTarde()
  }
}
</script>

<style scoped>
.version-outdated-modal {
  --background: rgba(15, 23, 42, 0.45);
  --width: 100%;
  --height: 100%;
}

.version-outdated-modal__wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding:
    max(16px, env(safe-area-inset-top, 0px))
    max(16px, env(safe-area-inset-right, 0px))
    max(16px, env(safe-area-inset-bottom, 0px))
    max(16px, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
}

.version-outdated-modal__spacer {
  flex: 1 1 0;
}

.version-outdated-modal__card {
  width: min(100%, 420px);
  margin-inline: auto;
  background: #fff;
  border-radius: 16px;
  padding: 22px 18px 16px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.22);
}

.version-outdated-modal__title {
  margin: 0 0 12px;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
}

.version-outdated-modal__text {
  margin: 0 0 10px;
  white-space: pre-wrap;
  line-height: 1.45;
  color: #334155;
}

.version-outdated-modal__meta {
  margin: 0 0 16px;
  font-size: 0.9rem;
  color: #64748b;
  text-align: center;
}

.version-outdated-modal__buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.version-outdated-modal__later {
  --color: #64748b;
  text-transform: none;
  margin: 0;
}
</style>
